import useSelector from './useSelector';

const useCooperativeId = () => {
  return useSelector((state) => state.settings.current_cooperative);
};

export default useCooperativeId;
